import React from 'react';
import {
    Button,
    FormGroup,
    Label, Input
  } from "reactstrap";

const FaxPopup = ({handleFax})=>{
    return(
            <div className="bg-white fax-popup">
              <h4 className="font-size-14 fw-medium">FAX</h4>
              <p className="font-size-14 fw-medium my-2 grey-color">Select fax number (CE)</p>
              <FormGroup check className="mb-2">
                <Input
                  name="radio2"
                  type="radio"
                />
                {' '}
                <Label check>
                  123 456 7890
                </Label>
              </FormGroup>
              <FormGroup check className="mb-2">
                <Input
                  name="radio2"
                  type="radio"
                />
                {' '}
                <Label check>
                  123 456 7890
                </Label>
              </FormGroup>
              <FormGroup className="mb-2"
                check
              >
                <Input
                  name="radio2"
                  type="radio"
                />
                {' '}
                <Label check>
                  123 456 7890
                </Label>
              </FormGroup>
              <div className="btn-row d-flex justify-content-end mt-4 pt-3">
              <Button onClick={handleFax} type="button" color="light" size="sm" className="border-0 me-3">
              Cancel
            </Button>
                <Button color="secondry" size="sm" >Send Fax</Button>
              </div>
            </div>
    )
}

export default FaxPopup;